import mList from '_v/common/m-list'
import orderTab from '_v/work-order/order-tabs'
import SelectRoom from '_vc/select-room'
import Dict from '_u/dict'
import { ymdL } from '_u/helper'
import { orderListOfPc, orderViewOfPc } from '@/api/work-order'

export default {
    mixins: [mList],
    components: {
        orderTab,
        SelectRoom,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            dict: {
                repairCategory: Dict.NULL,
                orderStatus: Dict.NULL,
                cusPayStatusList: [
                    { id: '0100', text: '未交费' },
                    { id: '0300', text: '已交费' },
                ],
                dispatchTypes: Dict.NULL,
            },
            modal: {
                showInformation: false,
            },
            curId: '',
            isPush: false,
            curWorkOrder: {},
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'code',
                    title: '工单号',
                    align: 'center',
                    minWidth: 180,
                },
                {
                    key: 'serviceCategoryText',
                    title: '维修类别',
                    align: 'center',
                    minWidth: 90,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    key: 'content',
                    title: '内容描述',
                    align: 'center',
                    minWidth: 160,
                },
                {
                    key: 'appointmentDate',
                    title: '期望上门时间',
                    align: 'center',
                    minWidth: 180,
                    slot: 'time',
                },
                {
                    key: 'statusText',
                    title: '工单状态',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'gdAmountText',
                    title: '工单费用',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'cuspaystatusText',
                    title: '交费状态',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'dispatchTypeText',
                    title: '委派类型',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'createUserName',
                    title: '提交人',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'createTime',
                    title: '提交时间',
                    align: 'center',
                    width: 180,
                    slot: 'time',
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 120,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        getServiceCategoryText(type, category) {
            //由于服务类别存储在两个词典中，因此需要根据服务类型判断使用哪个词典进行词典名称的获取
            var resultText = '未知'
            if (type == 'keepClean') {
                resultText = this.dict.keepCleanCategory.get(category).text
            }

            if (type == 'repair') {
                resultText = this.dict.repairCategory.get(category).text
            }

            return resultText
        },

        getTime(row, column) {
            return ymdL(row[column.key])
        },
        fetch() {
            this.loading = true
            return Promise.all([
                Dict.get('repair_category'),
                Dict.get('work_order_status'),
                Dict.get('dispatch_type'),
                orderListOfPc(this.filter),
            ])
                .then((args) => {
                    const [repairCategory, orderStatus, dispatchType, page] =
                        args
                    this.dict.repairCategory = repairCategory
                    this.dict.orderStatus = orderStatus
                    this.dict.dispatchTypes = dispatchType
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.page = 1
            this.fetch()
        },
        setPageData(data) {
            const { list } = data.page
            //获取词典名称
            list.forEach((v) => {
                //金额单位转元
                if (v.gdAmount && v.gdAmount > 0) {
                    v.gdAmountText = v.gdAmount / 100
                }

                if (v.serviceCategory.indexOf(',') != -1) {
                    var types = v.serviceCategory.split(',')
                    var typeText = ''
                    types.forEach((t) => {
                        typeText =
                            typeText +
                            ';' +
                            this.dict.repairCategory.get(t).text
                    })

                    v.serviceCategoryText = typeText.substr(1)
                } else {
                    v.serviceCategoryText = this.dict.repairCategory.get(
                        v.serviceCategory
                    ).text
                }

                v.statusText = this.dict.orderStatus.get(v.status).text
                v.dispatchTypeText = this.dict.dispatchTypes.get(
                    v.dispatchType
                ).text
                this.dict.cusPayStatusList.forEach((pStatus) => {
                    if (pStatus.id == v.feeStatus) {
                        v.cuspaystatusText = pStatus.text
                    }
                })
            })
            this.page.list = list

            this.page.total = parseInt(data.page.totalCount)
        },
        rowClickView(row) {
            //请求详情接口，获取数据 orderViewOfPc({ id: this.id })
            orderViewOfPc({ id: row.id }).then((res) => {
                this.curWorkOrder = res.data.entity
                this.formMode = this.FORM_MODE.view
                this.curId = row.id
                this.isPush = false
                this.modal.showInformation = true
            })
        },
        // 导出Excel
        onClickExport() {
            this.$refs.mt.exportToExcel()
        },
    },
}
